module.exports = __webpack_public_path__ + "DINNextLTPro-Light.woff2?260449068aae7c5f991a1d43bd9137a7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-Light.woff2
// module id = 1421
// module chunks = 0